<template lang="html">

  <section class="trip-info" >
    <div class="pageHeading text-xs-center">
      <h1>{{tripInfo.tripName}}</h1>
    </div>
    <v-container v-if="alreadyRegistered == false && registerForTrip == false" grid-list-md text-xs-center>
      <v-layout row wrap class="tripQuickInfo">
      <v-flex xs4 md4 >
        <span class="topTextBottomLabels">{{tripInfo.departDate | moment("MM/DD/YYYY")}}</span>
        <br/>
        <strong class="bottomLabels">Departure Date</strong>
      </v-flex>
        <v-flex xs4 md4 >
          <span class="topTextBottomLabels">{{tripInfo.returnDate | moment("MM/DD/YYYY")}}</span>
          <br/>
          <strong class="bottomLabels">Return Date</strong>
        </v-flex>
        <v-flex xs4 md4 >
          <span class="topTextBottomLabels">{{tripInfo.tripDestination}}</span>
          <br/>
          <strong class="bottomLabels">Destination</strong>
        </v-flex>
      </v-layout>
      <v-layout row wrap style="margin-top: 25px;">
        <v-flex xs12>
          <p>This trip leaves on {{tripInfo.departDate | moment("MMMM Do, YYYY")}}. The destination is {{tripInfo.tripDestination}}. Please make a deposit by {{tripInfo.depositPaymentDueDate | moment("MMMM Do, YYYY")}}</p>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <froalaView v-model="tripInfo.publicNotes"></froalaView>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <br/>
          <hr/>
          <br/>
          <v-btn color="secondary" @click="alreadyRegistered = true">I have Already Registered</v-btn>
          <v-btn color="primary" @click="registerForTrip = true">Register For This Trip</v-btn>

        </v-flex>
      </v-layout>
    </v-container>

      <v-container v-else-if="finalRegisterPage">
      <v-layout row wrap >
        <v-flex xs12>
          <h3>Do you have an account with us or <strong>need to create one?</strong></h3>
          <p>If you already have an account, please log in to manage your trip. If you need to create an account, you can do so by clicking the button below.</p>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <br/>
          <hr/>
          <br/>
          <v-btn color="secondary"  @click="$router.push('/Register')">Create New Account</v-btn>
          <v-btn color="primary"  @click="$router.push('/Login')">Login to Existing Account</v-btn>

        </v-flex>
      </v-layout>
    </v-container>
    <v-container v-else-if="alreadyRegistered">
      <v-layout row wrap >
        <v-flex xs12>
          <p>Since you have already registered, you can login and manage your participants & payments below</p>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <br/>
          <hr/>
          <br/>
          <v-btn color="secondary" @click="alreadyRegistered = false">Go Back</v-btn>
          <v-btn color="primary" @click="$router.push('/Login')">Login Now</v-btn>

        </v-flex>
      </v-layout>
    </v-container>
    <v-container v-else-if="registerForTrip">
      <v-layout row wrap >
        <v-flex xs12>
          <p>Lets get you started by logging into our portal where you can manage your participants. If you don't have an account, you will have the option to create one.</p>
          <span style="color:red">Note: If you are a director please contact us and we will create your director admin account.</span>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <br/>
          <hr/>
          <br/>
          <v-btn color="secondary" @click="registerForTrip = false">Go Back</v-btn>
          <v-btn color="primary" @click="finalRegisterPage = true">Continue</v-btn>

        </v-flex>
      </v-layout>
    </v-container>



  </section>

</template>

<script lang="js">
  export default  {
    name: 'trip-info',
    props: [],
    mounted() {
      this.lookupTripInfo()
    },
    data() {
      return {
        alreadyRegistered: false,
        finalRegisterPage: false,
        registerForTrip: false,
        tripInfo: {}
      }
    },
    methods: {
      registerTrip(tripID) {
        this.$cookies.set("tripToAdd",tripID);
        this.$router.push('/Login')
      },
      lookupTripInfo() {
        var vueThis = this;
        this.$services.trips.get(vueThis.$route.params.id)
            .then((result) => {
          console.log('trip look', result)
          if(result != undefined && result != null) {
            vueThis.tripInfo = result
          }
        })
      }
    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
.pageContentWrapper section {
  height: auto;
}

@media (min-width: 862px) {

  .trip-info {
    max-width: 650px;
    margin-left: auto;
    margin-right: auto;
  }
}

@media (max-width: 862px) {

  .trip-info {
    margin: 25px;
  }
}

.formPageWrapper {
  width: 100% !important;
}
.BottomLabels {
  text-decoration: overline;
  font-size: 12px;
  position: relative;
  top: -3px;
}

.topTextBottomLabels {
  font-size: 15px;
}

.tripListItemOpen{
  background-color: #1976d29e !important;
  color: white;
}

.tripListItemHidden{
  display: none;
}

.bottomLabels {
  text-decoration: overline;
  font-size: 12px !important;
  position: relative;
  top: -3px;
}

.bottomLabelsNoUnderline{
  font-size: 12px;
  position: relative;
  top: -3px;
}

.tripQuickInfo {
  max-width: 350px;
  margin-left: auto !important;
  margin-right: auto !important;
  padding: 15px;
  padding-bottom: 10px;
  box-shadow: 1px 4px 11px 1px #c1bfbf;
}
</style>
